export default __webpack_public_path__ + "static/media/bubblesLogo.f9f21287.png";